module.exports = __webpack_public_path__ + "static/media/benefits0.49184072.jpg";